import { FC, memo } from 'react';
import type { NodeToRenderProps } from '../types/custom-nodes.type';
import { applyStartingHocs } from '../../../scenario-editor/utils';
import { PlayComponent } from './PlayComponent';

export const NodeToRender: FC<NodeToRenderProps>  = PlayComponent as FC<NodeToRenderProps>;

const Node = applyStartingHocs(NodeToRender);

const NodeWithHandles: React.FC<NodeToRenderProps> = (props) => {
  return (
    <Node {...props}>{props.children}</Node>
  );
};

export const StartNode = memo(NodeWithHandles);
